import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return String(d);
};

export const post = (path, body, token) =>
  axios.post(`${API}${path}`, body, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
